import { FetchOptions } from "@decibeltrade/sdk";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";
import { useMarketContextsSubscription } from "../subscriptions/market-contexts";

export function marketContextsQueryKey() {
  return ["market-contexts"] as const;
}

export function marketContextsQuery(fetchOptions?: FetchOptions) {
  return {
    queryKey: marketContextsQueryKey(),
    queryFn: async () => {
      return await readDexSdk.marketContexts.getAll({ fetchOptions });
    },
    // The server caches asset_contexts for 10s, so a 30s poll costs it nothing.
    refetchInterval: 1000 * 30,
  };
}

export function useMarketContexts() {
  useMarketContextsSubscription();
  return useSuspenseQuery(marketContextsQuery());
}

export function useMarketContextsQuery() {
  useMarketContextsSubscription();
  return useQuery(marketContextsQuery());
}

export function useMarketContext(marketName: string) {
  const { data: marketContexts } = useMarketContexts();
  const marketContext = marketContexts.find((marketContext) => marketContext.market === marketName);

  if (!marketContext) {
    throw new Error(`Market context not found for market ${marketName}`);
  }

  return marketContext;
}
